import type { SVGProps } from 'react';
import { icons, type IconName } from '../../content/site';

/**
 * Çizgi ikon. Renk `currentColor`'dan gelir; ikon her zaman dekoratiftir,
 * erişilebilir adı onu saran buton ya da bağlantı taşır.
 */
export function Icon({
  name,
  size = 18,
  strokeWidth = 1.8,
  ...rest
}: { name: IconName; size?: number; strokeWidth?: number } & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <path d={icons[name]} />
    </svg>
  );
}
